export default "https://cdn-static.gokick.com/assets/76516c8a60965c2814adf9f2d5cc0638cda6ee5d/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";